var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238.66 89.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6141e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m51.13,13.71L43.46,0h1.46l7.7,13.71h-1.47Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.91,13.07v-1.22h8v1.22h-8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m65.79,13.07v-1.22h8v1.22h-8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m76.67,13.07v-1.22h8v1.22h-8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m87.55,13.07v-1.22h8v1.22h-8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m98.43,13.07v-1.22h8v1.22h-8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m109.31,13.07v-1.22h8v1.22h-8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120.19,13.07v-1.22h8v1.22h-8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m131.07,13.07v-1.22h8v1.22h-8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,26.83v-1.42c.16-.18.37-.37.62-.56s.55-.35.9-.49c.34-.13.7-.2,1.09-.2.34,0,.67.05.98.16.31.11.61.23.91.37s.61.26.92.37c.31.11.65.16,1,.16.38,0,.74-.07,1.08-.2.34-.13.64-.3.9-.49s.47-.38.62-.56v1.42c-.15.18-.36.37-.62.56s-.57.35-.9.49-.7.2-1.08.2c-.34,0-.67-.05-.98-.16-.31-.11-.61-.23-.91-.37-.3-.14-.61-.26-.92-.37-.32-.11-.65-.16-1-.16-.38,0-.75.07-1.09.2-.34.13-.64.3-.9.49-.26.19-.46.38-.62.56Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.01,32.91l-7.68-13.71h1.46l7.7,13.71h-1.47Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m66.19,30.18l.62-2.85h-1.71v-1.28h2l.54-2.4h-1.9v-1.3h2.18l.74-3.31h1.38l-.75,3.31h2.26l.74-3.31h1.36l-.77,3.31h1.63v1.3h-1.89l-.53,2.4h1.86v1.28h-2.16l-.62,2.85h-1.34l.62-2.85h-2.27l-.62,2.85h-1.34Zm2.26-4.13h2.27l.56-2.4h-2.29l-.54,2.4Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m77.07,30.18l.62-2.85h-1.71v-1.28h2l.54-2.4h-1.9v-1.3h2.18l.74-3.31h1.38l-.75,3.31h2.26l.74-3.31h1.36l-.77,3.31h1.63v1.3h-1.89l-.53,2.4h1.86v1.28h-2.16l-.62,2.85h-1.34l.62-2.85h-2.27l-.62,2.85h-1.34Zm2.26-4.13h2.27l.56-2.4h-2.29l-.54,2.4Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m87.95,30.18l.62-2.85h-1.71v-1.28h2l.54-2.4h-1.9v-1.3h2.18l.74-3.31h1.38l-.75,3.31h2.26l.74-3.31h1.36l-.77,3.31h1.63v1.3h-1.89l-.53,2.4h1.86v1.28h-2.16l-.62,2.85h-1.34l.62-2.85h-2.27l-.62,2.85h-1.34Zm2.26-4.13h2.27l.56-2.4h-2.29l-.54,2.4Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m98.83,30.18l.62-2.85h-1.71v-1.28h2l.54-2.4h-1.9v-1.3h2.18l.74-3.31h1.38l-.75,3.31h2.26l.74-3.31h1.36l-.77,3.31h1.63v1.3h-1.89l-.53,2.4h1.86v1.28h-2.16l-.62,2.85h-1.34l.62-2.85h-2.27l-.62,2.85h-1.34Zm2.26-4.13h2.27l.56-2.4h-2.29l-.54,2.4Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m109.71,30.18l.62-2.85h-1.71v-1.28h2l.54-2.4h-1.9v-1.3h2.18l.74-3.31h1.38l-.75,3.31h2.26l.74-3.31h1.36l-.77,3.31h1.63v1.3h-1.89l-.53,2.4h1.86v1.28h-2.16l-.62,2.85h-1.34l.62-2.85h-2.27l-.62,2.85h-1.34Zm2.26-4.13h2.27l.56-2.4h-2.29l-.54,2.4Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120.59,30.18l.62-2.85h-1.71v-1.28h2l.54-2.4h-1.9v-1.3h2.18l.74-3.31h1.38l-.75,3.31h2.26l.74-3.31h1.36l-.77,3.31h1.63v1.3h-1.89l-.53,2.4h1.86v1.28h-2.16l-.62,2.85h-1.34l.62-2.85h-2.27l-.62,2.85h-1.34Zm2.26-4.13h2.27l.56-2.4h-2.29l-.54,2.4Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m130.49,32.91l7.7-13.71h1.46l-7.68,13.71h-1.47Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.76,46.03v-1.42c.16-.18.37-.37.62-.56s.55-.35.9-.49c.34-.13.7-.2,1.09-.2.34,0,.67.05.98.16.31.11.61.23.91.37s.61.26.92.37c.31.11.65.16,1,.16.38,0,.74-.07,1.08-.2.34-.13.64-.3.9-.49s.47-.38.62-.56v1.42c-.15.18-.36.37-.62.56s-.57.35-.9.49-.7.2-1.08.2c-.34,0-.67-.05-.98-.16-.31-.11-.61-.23-.91-.37-.3-.14-.61-.26-.92-.37-.32-.11-.65-.16-1-.16-.38,0-.75.07-1.09.2-.34.13-.64.3-.9.49-.26.19-.46.38-.62.56Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m69.13,52.58v-14.72h1.31v14.72h-1.31Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m77.07,49.38l.62-2.85h-1.71v-1.28h2l.54-2.4h-1.9v-1.3h2.18l.74-3.31h1.38l-.75,3.31h2.26l.74-3.31h1.36l-.77,3.31h1.63v1.3h-1.89l-.53,2.4h1.86v1.28h-2.16l-.62,2.85h-1.34l.62-2.85h-2.27l-.62,2.85h-1.34Zm2.26-4.13h2.27l.56-2.4h-2.29l-.54,2.4Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m87.95,49.38l.62-2.85h-1.71v-1.28h2l.54-2.4h-1.9v-1.3h2.18l.74-3.31h1.38l-.75,3.31h2.26l.74-3.31h1.36l-.77,3.31h1.63v1.3h-1.89l-.53,2.4h1.86v1.28h-2.16l-.62,2.85h-1.34l.62-2.85h-2.27l-.62,2.85h-1.34Zm2.26-4.13h2.27l.56-2.4h-2.29l-.54,2.4Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m98.83,49.38l.62-2.85h-1.71v-1.28h2l.54-2.4h-1.9v-1.3h2.18l.74-3.31h1.38l-.75,3.31h2.26l.74-3.31h1.36l-.77,3.31h1.63v1.3h-1.89l-.53,2.4h1.86v1.28h-2.16l-.62,2.85h-1.34l.62-2.85h-2.27l-.62,2.85h-1.34Zm2.26-4.13h2.27l.56-2.4h-2.29l-.54,2.4Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m109.71,49.38l.62-2.85h-1.71v-1.28h2l.54-2.4h-1.9v-1.3h2.18l.74-3.31h1.38l-.75,3.31h2.26l.74-3.31h1.36l-.77,3.31h1.63v1.3h-1.89l-.53,2.4h1.86v1.28h-2.16l-.62,2.85h-1.34l.62-2.85h-2.27l-.62,2.85h-1.34Zm2.26-4.13h2.27l.56-2.4h-2.29l-.54,2.4Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m119.61,52.11l7.7-13.71h1.46l-7.68,13.71h-1.47Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.88,65.23v-1.42c.16-.18.37-.37.62-.56s.55-.35.9-.49c.34-.13.7-.2,1.09-.2.34,0,.67.05.98.16.31.11.61.23.91.37s.61.26.92.37c.31.11.65.16,1,.16.38,0,.74-.07,1.08-.2.34-.13.64-.3.9-.49s.47-.38.62-.56v1.42c-.15.18-.36.37-.62.56s-.57.35-.9.49-.7.2-1.08.2c-.34,0-.67-.05-.98-.16-.31-.11-.61-.23-.91-.37-.3-.14-.61-.26-.92-.37-.32-.11-.65-.16-1-.16-.38,0-.75.07-1.09.2-.34.13-.64.3-.9.49-.26.19-.46.38-.62.56Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m69.13,71.78v-14.72h1.31v14.72h-1.31Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m76.67,70.67v-1.22h8v1.22h-8Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m87.55,70.67v-1.22h8v1.22h-8Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m98.43,70.67v-1.22h8v1.22h-8Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m109.31,70.67v-1.22h8v1.22h-8Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.07,68.58v-2.13h2.24v2.13h-2.24Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2.19,89.87v-1.22h8v1.22H2.19Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.07,89.87v-1.22h8v1.22h-8Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.95,89.87v-1.22h8v1.22h-8Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m34.83,89.87v-1.22h8v1.22h-8Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m45.71,89.87v-1.22h8v1.22h-8Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.59,89.87v-1.22h8v1.22h-8Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.47,87.94c-.81,0-1.51-.18-2.09-.53-.58-.35-1.03-.84-1.34-1.46-.31-.62-.46-1.33-.46-2.12v-.27c0-.81.15-1.52.46-2.14.31-.62.75-1.1,1.34-1.45.58-.35,1.27-.52,2.07-.52s1.52.18,2.1.53,1.03.84,1.34,1.46.46,1.33.46,2.13v.27c0,.81-.15,1.53-.46,2.14-.31.62-.75,1.1-1.34,1.45s-1.28.52-2.09.52Zm0-1.26c.57,0,1.03-.21,1.39-.62.36-.42.54-.99.54-1.71v-1.3c0-.73-.18-1.3-.54-1.71-.36-.42-.83-.62-1.39-.62s-1.02.21-1.38.62c-.37.42-.55.99-.55,1.71v1.3c0,.73.18,1.3.55,1.71s.83.62,1.38.62Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m78.35,89.87v-1.22h8v1.22h-8Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m89.23,89.87v-1.22h8v1.22h-8Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m100.11,89.87v-1.22h8v1.22h-8Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m110.99,89.87v-1.22h8v1.22h-8Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m125.87,87.94c-.81,0-1.51-.18-2.09-.53-.58-.35-1.03-.84-1.34-1.46-.31-.62-.46-1.33-.46-2.12v-.27c0-.81.15-1.52.46-2.14.31-.62.75-1.1,1.34-1.45.58-.35,1.27-.52,2.07-.52s1.52.18,2.1.53,1.03.84,1.34,1.46.46,1.33.46,2.13v.27c0,.81-.15,1.53-.46,2.14-.31.62-.75,1.1-1.34,1.45s-1.28.52-2.09.52Zm0-1.26c.57,0,1.03-.21,1.39-.62.36-.42.54-.99.54-1.71v-1.3c0-.73-.18-1.3-.54-1.71-.36-.42-.83-.62-1.39-.62s-1.02.21-1.38.62c-.37.42-.55.99-.55,1.71v1.3c0,.73.18,1.3.55,1.71s.83.62,1.38.62Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m132.75,89.87v-1.22h8v1.22h-8Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m143.63,89.87v-1.22h8v1.22h-8Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m154.51,89.87v-1.22h8v1.22h-8Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m165.38,89.87v-1.22h8v1.22h-8Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m176.26,89.87v-1.22h8v1.22h-8Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m187.14,89.87v-1.22h8v1.22h-8Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m198.02,89.87v-1.22h8v1.22h-8Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m208.9,89.87v-1.22h8v1.22h-8Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m219.78,89.87v-1.22h8v1.22h-8Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m230.66,89.87v-1.22h8v1.22h-8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.61d337634f46c738181fe43925685994.svg";
export { ForwardRef as ReactComponent };